// @flow

import * as React from 'react';

import { useLocation, useMatch } from 'react-router-dom';
import { View, Text } from 'reshaped';

import { useTranslator } from '@gandi/translate';
import { TextPlaceholder } from '@gandi/ui';

import { selectIsPricing } from 'src/Cart/modules/selectors';
import { useAppSelector } from 'src/hooks/useAppSelector';

type Props = {
  amount?: number,
  currency?: string,
};

function TotalRow({ currency, amount }: Props): React.Node {
  const { __, formatPrice } = useTranslator();

  const location = useLocation();
  const accountStudioPage = Boolean(useMatch('/studio/:cartId/account'));

  const accountChoicePage = location.pathname.includes(
    '/configure/account-choice',
  );

  const productIsPricing = useAppSelector(selectIsPricing);

  if (amount === undefined) return null;

  const displayPlaceholder =
    productIsPricing && (accountChoicePage || accountStudioPage);

  return (
    <View direction="row" justify="space-between">
      <Text as="p" variant="featured-3" weight="bold">
        {__('Total')}
      </Text>
      {displayPlaceholder ? (
        <TextPlaceholder />
      ) : (
        <Text as="p" variant="featured-3" weight="bold">
          {formatPrice(amount, currency)}
        </Text>
      )}
    </View>
  );
}

export default TotalRow;
